'use strict';

(function (angular) {
  'use strict';

  angular.module('google.places').service('locationValidator', locationValidator);

  /** @ngInject */
  function locationValidator($q) {
    var service = this;

    service.validate = validate;

    /////////////////////////////////////

    function validate(location) {

      var deferred = $q.defer();

      var result = {
        valid: true,
        notDefined: false,
        streetNumberMissing: false,
        streetIsMissing: false,
        cityIsMissing: false,
        countryIsMissing: false
      };

      if (!location || !angular.isObject(location)) {
        result.valid = false;
        result.notDefined = true;
      }

      if (!getAddressComponent(location, 'street_number').long_name) {
        result.valid = false;
        result.streetNumberMissing = true;
      }

      if (!getAddressComponent(location, 'route').long_name) {
        result.valid = false;
        result.streetIsMissing = true;
      }

      if (!getAddressComponent(location, 'locality').long_name) {
        result.valid = false;
        result.cityIsMissing = true;
      }

      if (!getAddressComponent(location, 'country').long_name) {
        result.valid = false;
        result.countryIsMissing = true;
      }

      if (result.valid) {
        deferred.resolve(result);
      } else {
        deferred.reject(result);
      }

      return deferred.promise;
    }

    function getAddressComponent(location, type) {
      if (!!location && !!location.address_components) {
        for (var i in location.address_components) {
          for (var j in location.address_components[i].types) {
            if (location.address_components[i].types[j] === type) {
              return location.address_components[i];
            }
          }
        }
      }
      return {
        long_name: null,
        short_name: null
      };
    }
  }
})(window.angular);